import Vue from 'vue';
import { IsString, IsNull, IsNotEmptyArray } from '@/utils/utils';
import router from '@/routes/router';

export const FooterButtonType = {
    Confirm: 'Confirm',
    Cancel: 'Cancel',
};

const ModalPlugin = {
    install: function() {
        Vue.prototype.$modal = {
            seed: 0,
            instances: [],
            show(options) {
                if (typeof options.showFooter !== 'boolean') {
                    options.showFooter = true;
                }
                if (typeof options.showScreenBtn !== 'boolean') {
                    options.showScreenBtn = false;
                }
                if (typeof options.needConfirm !== 'boolean') {
                    options.needConfirm = false;
                }
                if (options.needConfirm) {
                    options.showFooter = true;
                }
                const id = 'ic_modal_' + this.seed++;
                const content = options.content;
                const contentStyle = {
                    overflowY: 'auto',
                    overflowX: 'hidden',
                };
                if (options.height) {
                    contentStyle.height = options.height;
                }
                if (options.minHeight) {
                    contentStyle['min-height'] = options.minHeight;
                }

                const instance = new Vue({
                    router,
                    parent: Vue.prototype.$root,
                    render: function(h) {
                        const contentIsString = IsString(content);
                        let contentVNode = null;
                        if (contentIsString) {
                            if (options.contentIsHTML) {
                                contentVNode = h('div', {
                                    style: contentStyle,
                                    domProps: {
                                        innerHTML: content,
                                    },
                                });
                            } else {
                                contentVNode = h(
                                    'div',
                                    {
                                        style: contentStyle,
                                    },
                                    content
                                );
                            }
                        } else {
                            contentVNode = h(content, {
                                style: contentStyle,
                                props: options.componentParams,
                                on: {
                                    ...options.componentOn,
                                    modalClose: () => {
                                        this.close();
                                    },
                                    cancel: () => {
                                        this.cancel();
                                    },
                                    confirm: data => {
                                        this.setDataAndConfirm(data);
                                    },
                                    'set-data': data => {
                                        this.componentData = data;
                                    },
                                },
                            });
                        }

                        const dialogChildrenVNode = new Array();
                        const dialogHeaderVNode = new Array();
                        const dialogTitleVNode = new Array();
                        if (options.showFooter) {
                            let footerChildren = [];
                            if (options.needConfirm) {
                                footerChildren.push(
                                    h('el-checkbox', {
                                        props: {
                                            label: options.confirmText,
                                        },
                                        on: {
                                            change: event => {
                                                this.disabled = !event;
                                            },
                                        },
                                        style: {
                                            float: 'left',
                                        },
                                    })
                                );
                            }
                            //如果配置了footerButtons,则显示
                            if (IsNotEmptyArray(options.footerButtons)) {
                                options.footerButtons.map(footerButton => {
                                    footerChildren.push(
                                        h(
                                            'el-button',
                                            {
                                                props: {
                                                    type:
                                                        footerButton.type ===
                                                        FooterButtonType.Confirm
                                                            ? 'primary'
                                                            : undefined,
                                                    loading:
                                                        footerButton.type ===
                                                        FooterButtonType.Confirm
                                                            ? this.confirmLoading
                                                            : footerButton.type ===
                                                              FooterButtonType.Cancel
                                                            ? this.cancelLoading
                                                            : undefined,
                                                    disabled: this.disabled == true ? true : false,
                                                },
                                                on: {
                                                    click: () => {
                                                        switch (footerButton.type) {
                                                            case FooterButtonType.Confirm:
                                                                this.disabled = true;
                                                                this.confirmHandler(
                                                                    contentVNode.child
                                                                        ? contentVNode.child
                                                                              .confirmAction
                                                                        : null
                                                                );
                                                                break;
                                                            case FooterButtonType.Cancel:
                                                                this.cancelHandler(
                                                                    contentVNode.child
                                                                        ? contentVNode.child
                                                                              .cancelAction
                                                                        : null
                                                                );
                                                                break;
                                                        }
                                                    },
                                                },
                                                style: {
                                                    float: 'right',
                                                    margin: '20px 0 0 0',
                                                },
                                            },
                                            [
                                                !IsNull(footerButton.title)
                                                    ? footerButton.title
                                                    : footerButton.type === FooterButtonType.Confirm
                                                    ? '确 定'
                                                    : '取 消',
                                            ]
                                        )
                                    );
                                });
                            } else {
                                footerChildren.push(
                                    h(
                                        'el-button',
                                        {
                                            props: {
                                                type: 'primary',
                                                loading: this.confirmLoading,
                                                disabled: this.disabled == true ? true : false,
                                            },
                                            on: {
                                                click: () => {
                                                    this.disabled = true;
                                                    this.confirmHandler(
                                                        contentVNode.child
                                                            ? contentVNode.child.confirmAction
                                                            : null
                                                    );
                                                },
                                            },
                                            style: {
                                                float: 'right',
                                                margin: '20px 0 0 0',
                                            },
                                        },
                                        [
                                            !IsNull(options.btnYesText) && options.btnYesText.trim()
                                                ? options.btnYesText
                                                : '确 定',
                                        ]
                                    )
                                );
                                footerChildren.push(
                                    h(
                                        'el-button',
                                        {
                                            props: {
                                                loading: this.cancelLoading,
                                            },
                                            on: {
                                                click: () => {
                                                    this.cancelHandler(
                                                        contentVNode.child
                                                            ? contentVNode.child.cancelAction
                                                            : null
                                                    );
                                                },
                                            },
                                            style: {
                                                float: 'right',
                                                margin: '20px 20px 0 0',
                                            },
                                        },
                                        ['取 消']
                                    )
                                );
                            }
                            dialogChildrenVNode.push(
                                h(
                                    'div',
                                    {
                                        slot: 'footer',
                                    },
                                    footerChildren
                                )
                            );
                        }
                        if (options.showScreenBtn) {
                            let headerChildren = [];
                            let titleChildren = [];
                            titleChildren.push(
                                h(
                                    'span',
                                    {
                                        slot: 'title',
                                        style: {
                                            'line-height': '24px',
                                            'font-size': '18px',
                                            color: '#303133',
                                        },
                                    },
                                    [options.title]
                                )
                            );
                            titleChildren.push(
                                h('el-button', {
                                    props: {
                                        loading: this.cancelLoading,
                                        icon: 'el-icon-full-screen',
                                    },
                                    on: {
                                        click: () => {
                                            this.fullscreen = !this.fullscreen;
                                        },
                                    },
                                    style: {
                                        float: 'right',
                                        display: this.fullscreen ? 'none' : 'block',
                                        margin: ' -6px 10px 0 0',
                                    },
                                })
                            );
                            dialogTitleVNode.push(
                                h(
                                    'div',
                                    {
                                        slot: 'title',
                                        style: {
                                            height: '40px',
                                        },
                                    },
                                    titleChildren
                                )
                            );
                            headerChildren.push(
                                h(
                                    'span',
                                    {
                                        slot: 'title',
                                        style: {
                                            'line-height': '24px',
                                            'font-size': '18px',
                                            color: '#303133',
                                        },
                                    },
                                    [options.title]
                                )
                            );
                            headerChildren.push(
                                h('el-button', {
                                    props: {
                                        loading: this.cancelLoading,
                                        icon: 'el-icon-copy-document',
                                    },
                                    on: {
                                        click: () => {
                                            this.fullscreen = !this.fullscreen;
                                        },
                                    },
                                    style: {
                                        float: 'right',
                                    },
                                })
                            );
                            dialogHeaderVNode.push(
                                h(
                                    'div',
                                    {
                                        slot: 'title',
                                        style: {
                                            height: '60px',
                                            display: this.fullscreen ? 'block' : 'none',
                                            padding: '10px',
                                        },
                                    },
                                    headerChildren
                                )
                            );
                        }

                        let that = this;

                        return h(
                            'el-dialog',
                            {
                                props: {
                                    title: options.title,
                                    width: options.width,
                                    top: options.top ? options.top : '15vh',
                                    customClass: options.customClass,
                                    visible: true,
                                    fullscreen: this.fullscreen,
                                    appendToBody: true,
                                    modal: !this.fullscreen,
                                    'close-on-click-modal': false,
                                    beforeClose: hide => {
                                        hide();
                                    },
                                },
                                on: {
                                    close: () => {
                                        that.cancel();
                                    },
                                },
                                scopedSlots: {
                                    default: () => {
                                        if (contentIsString) {
                                            return h(
                                                'div',
                                                {
                                                    class: {
                                                        modal_full_screen_class: this.fullscreen,
                                                    },
                                                    style: {
                                                        'background-color': 'white',
                                                    },
                                                },
                                                [
                                                    dialogHeaderVNode,
                                                    contentVNode,
                                                    dialogChildrenVNode,
                                                ]
                                            );
                                        } else {
                                            return h(
                                                'div',
                                                {
                                                    class: {
                                                        modal_full_screen_class: this.fullscreen,
                                                    },
                                                    style: {
                                                        'background-color': 'white',
                                                    },
                                                },
                                                [
                                                    dialogHeaderVNode,
                                                    contentVNode,
                                                    dialogChildrenVNode,
                                                ]
                                            );
                                        }
                                    },
                                },
                            },
                            dialogTitleVNode
                        );
                    },
                    data: function() {
                        return {
                            componentData: null,
                            confirmLoading: false,
                            cancelLoading: false,
                            disabled: options.needConfirm === true,
                            fullscreen: options.fullscreen,
                        };
                    },
                    props: {
                        visible: {
                            type: Boolean,
                            default: false,
                        },
                    },
                    methods: {
                        confirmHandler(confirmAction) {
                            if (typeof confirmAction === 'function') {
                                const functionReturn = confirmAction();
                                if (functionReturn instanceof Promise) {
                                    this.confirmLoading = true;
                                    functionReturn
                                        .then(() => {
                                            this.confirmLoading = false;
                                            this.disabled = false;
                                        })
                                        .catch(() => {
                                            this.disabled = false;
                                            this.confirmLoading = false;
                                        });
                                } else {
                                    this.disabled = false;
                                }
                            } else {
                                this.confirm();
                                this.disabled = false;
                            }
                        },
                        cancelHandler(cancelAction) {
                            if (typeof cancelAction === 'function') {
                                const functionReturn = cancelAction();
                                if (functionReturn instanceof Promise) {
                                    this.cancelLoading = true;
                                    functionReturn.then(() => {
                                        this.cancelLoading = false;
                                    });
                                }
                            } else {
                                this.cancel();
                            }
                        },
                        close: function() {
                            this.cancel();
                        },
                        cancel: function() {
                            this.closed();
                            if (typeof options.cancelHandler === 'function') {
                                options.cancelHandler();
                            }
                        },
                        confirm: function() {
                            if (typeof options.beforConfirmHandler === 'function') {
                                const functionReturn = options.beforConfirmHandler(
                                    this.componentData
                                );
                                if (functionReturn instanceof Promise) {
                                    this.confirmLoading = true;
                                    functionReturn
                                        .then(res => {
                                            this.confirmLoading = false;
                                            if (res) {
                                                this.closed();
                                                if (typeof options.confirmHandler === 'function') {
                                                    options.confirmHandler(this.componentData);
                                                }
                                            }
                                        })
                                        .catch(() => {
                                            this.confirmLoading = false;
                                        });
                                } else {
                                    if (functionReturn) {
                                        this.closed();
                                        if (typeof options.confirmHandler === 'function') {
                                            options.confirmHandler(this.componentData);
                                        }
                                    }
                                }
                            } else {
                                this.closed();
                                if (typeof options.confirmHandler === 'function') {
                                    options.confirmHandler(this.componentData);
                                }
                            }
                        },
                        setDataAndConfirm: function(data) {
                            this.componentData = data;
                            this.confirm();
                        },
                        closed: function() {
                            this.$modal.close(this.id);
                            if (typeof options.closed === 'function') {
                                options.closed();
                            }
                        },
                    },
                });

                instance.id = id;
                instance.vm = instance.$mount();
                //instance.$props.visible = true;
                this.instances.push(instance);
                return instance;
            },
            close(id) {
                for (let i = 0; i < this.instances.length; i++) {
                    const instance = this.instances[i];
                    if (id === instance.id) {
                        instance.$destroy();
                        this.instances.splice(i, 1);
                        break;
                    }
                }
            },
        };
    },
};

Vue.use(ModalPlugin);
